import { createSelector } from 'reselect';

const selectGlobalIssueCategories = (state: any) => state.globalIssueCategories;

export const selectGlobalIssueCategoriesCurrentItem = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.current);

export const selectGlobalIssueCategoriesListItems = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalIssueCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalIssueCategoriesQueryItems = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.query);

export const selectGlobalIssueCategoriesCreatedItem = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.create);

export const selectGlobalIssueCategoriesUpdatedItem = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.update);

export const selectGlobalIssueCategoriesReadItem = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.read);

export const selectGlobalIssueCategoriesDeletedItem = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.delete);

export const selectGlobalIssueCategoriesSearchedItems = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.search);

export const selectGlobalIssueCategoriesItemsCount = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.count);

export const selectGlobalIssueCategoriesItemsFilter = createSelector([selectGlobalIssueCategories], (globalIssueCategories) => globalIssueCategories.filter);